export const images = [
  '../../assets/icon/burraga-logo.svg',
  '../../assets/icon/cross-circled.svg',
  '../../assets/icon/edit-circled.svg',
  '../../assets/icon/favicon.png',
  '../../assets/icon/icon-achievements.svg',
  '../../assets/icon/icon-dictionary.svg',
  '../../assets/icon/icon-logo-out.svg',
  '../../assets/icon/listen.svg',
  '../../assets/icon/map-circle.svg',
  '../../assets/icon/map-level-lock.svg',
  '../../assets/icon/nav-icon-map.svg',
  '../../assets/icon/side-dot.svg',
  '../../assets/icon/swap.svg',
  '../../assets/icon/tick-circled.svg',
  '../../assets/img/avatar-badge.svg',
  '../../assets/img/body-parts-arm.svg',
  '../../assets/img/body-parts-foot.svg',
  '../../assets/img/body-parts-full-body1.svg',
  '../../assets/img/body-parts-full-body2.svg',
  '../../assets/img/body-parts-full-body3.svg',
  '../../assets/img/body-parts-full-body4.svg',
  '../../assets/img/body-parts-full-body5.svg',
  '../../assets/img/body-parts-full-body6.svg',
  '../../assets/img/body-parts-full-body7.svg',
  '../../assets/img/body-parts-head.svg',
  '../../assets/img/body-parts-head2.svg',
  '../../assets/img/body-parts-head3.svg',
  '../../assets/img/body-parts-head4.svg',
  '../../assets/img/body-parts-head5.svg',
  '../../assets/img/body-parts-head6.svg',
  '../../assets/img/body-parts-head7.svg',
  '../../assets/img/body-parts-head8.svg',
  '../../assets/img/rings.svg',
  '../../assets/img/game-path.svg',
  '../../assets/img/dictionary.200px.png',
  '../../assets/img/bye.200px.png',
  '../../assets/img/scene-beach.200px.png',
  '../../assets/img/scene-land.200px.png',
  '../../assets/img/catch.200px.png',
  '../../assets/img/cm-help-dictionary-add-sound.200px.png',
  '../../assets/img/cm-help-dictionary-add-word.200px.png',
  '../../assets/img/cm-help-dictionary-intro.200px.png',
  '../../assets/img/cm-help-map-intro.200px.png',
  '../../assets/img/cm-help-map-new-level.200px.png',
  '../../assets/img/cm-help-map-new.200px.png',
  '../../assets/img/cm-help-map-sequence-game.200px.png',
  '../../assets/img/cm-help-map-sequence.200px.png',
  '../../assets/img/cm-help-map-side-activity.200px.png',
  '../../assets/img/cm-help-media-add.200px.png',
  '../../assets/img/cm-help-media-intro.200px.png',
  '../../assets/img/cm-help-users-intro.200px.png',
  '../../assets/img/cm-help-users-manage.200px.png',
  '../../assets/img/missing-image.200px.png',
  '../../assets/img/missing-image_mono.200px.png',
]
